import { createAction } from 'redux-actions';

export const requestGetSearchThreadMessagesByStringAction = createAction(
  'REQUEST/GET_SEARCH_THREAD_MESSAGES_BY_STRING',
);
export const searchMessagesClearDataAction = createAction('SEARCH_MESSAGES/CLEAR_DATA');
